(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*var isSearchOpen = false;
  // console.log(document.getElementById("is-search-bar").getAttribute("open"));
  if(document.getElementById("is-search-bar") != "undefined"){
    (document.getElementById("is-search-bar")).addEventListener("onclick", function(){
      isSearchOpen = (document.getElementById("is-search-bar")).getAttribute("open");
      alert(isSearchOpen);
      if(isSearchOpen){
        document.getElementById("is-search-bar").classList.add("is-search-open");
      }
    });
  }*/

  } catch(e) { console.error(e); }
})();

})();
